import { render, staticRenderFns } from "./MyNavbarFooter.vue?vue&type=template&id=48f1a214&scoped=true&"
import script from "./MyNavbarFooter.vue?vue&type=script&lang=js&"
export * from "./MyNavbarFooter.vue?vue&type=script&lang=js&"
import style0 from "./MyNavbarFooter.vue?vue&type=style&index=0&id=48f1a214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1a214",
  null
  
)

export default component.exports